import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/ui/theme-toggle";
import { Menu, Sparkles, X } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate, useParams } from "react-router-dom";

interface HeaderProps {
  onMobileMenuToggle?: () => void;
}

export function Header({ onMobileMenuToggle }: HeaderProps) {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const { lang } = useParams();

  return (
    <>
    <header className="h-16 border-b border-border/50 bg-card/30 backdrop-blur-xl sticky top-0 z-40">
      <div className="flex items-center justify-between h-full px-4 lg:px-6">
        <div className="flex items-center gap-4">
          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="sm"
            className="lg:hidden hover:bg-muted/50"
            onClick={onMobileMenuToggle}
          >
            <Menu className="w-5 h-5" />
          </Button>
          
          <div className="flex items-center gap-2">
            <Sparkles className="w-6 h-6 text-ai-primary" />
            <h1 className="text-lg lg:text-xl font-semibold hidden sm:block">Sarvalok AI Workspace</h1>
            <h1 className="text-lg font-semibold sm:hidden">AI</h1>
          </div>
        </div>
        
        <div className="flex items-center gap-2 lg:gap-4">
          <ThemeToggle />

          {/* Close button to return to localized chat page */}
          <Button
            variant="ghost"
            size="sm"
            className="hover:bg-muted/50 rounded-full border border-slate-200 dark:border-neutral-700 h-8 w-8 p-0 flex items-center justify-center"
            onClick={() => navigate(`/${lang || 'en'}/chat`)}
            title="Close and return to chat"
          >
            <X className="w-4 h-4" />
          </Button>



          
        </div>
      </div>
    </header>
    </>
  );
}